import * as React from 'react';
import { ProspectInfoRow } from '../dashboardWidgets/prospectInfoRow';
import { relationshipTypeDisplay } from '../../../../utilities/formatting';
import { AdditionalResident } from '../../../../api/Prospect';

export const AdditionalResidentCard = ({ res }: { res: AdditionalResident }) => (
    <>
        <ProspectInfoRow label={`${res.firstName} ${res.lastName}`} includeTopSpacer={true} />
        <ProspectInfoRow
            label="Relationship"
            value={relationshipTypeDisplay(res.relationshipType)}
        />
        <ProspectInfoRow label="Email" value={res.email} optional={true} />
        <ProspectInfoRow label="Phone" value={res.phone} optional={true} />
    </>
);


// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/additionalResidentCard.tsx